import { combineReducers, configureStore } from "@reduxjs/toolkit";

import kaboodleReducer from "reducers/main";
import claimSlice from "reducers/claims";
import rreSlice from "reducers/rre";
import clientSlice from "reducers/client";
import filesSlice from "reducers/files";
import drawerSlice from "reducers/drawer";
import metadocSlice from "reducers/metadoc";
import ratedAgeOCRSlice from "reducers/rated-age-ocr";
import { rtkQueryErrorLogger } from "services/middleware";
import { api } from "services/api.ts";
import claimsDataSlice from "services/claimsDataSlice.ts";
import sharedSlice from "services/sharedSlice";
import liensSlice from "reducers/liens";
import futureMedicalReducer from "reducers/future-medical";
const baseReducers = {
  [api.reducerPath]: api.reducer,
  main: kaboodleReducer,
  claim: claimSlice,
  client: clientSlice,
  rre: rreSlice,
  claimsForm: claimsDataSlice,
  shared: sharedSlice,
  files: filesSlice,
  liens: liensSlice,
  futureMedical: futureMedicalReducer,
  drawer: drawerSlice,
  metadoc: metadocSlice,
  ratedAgeOCR: ratedAgeOCRSlice,
};

const rootReducer = combineReducers(baseReducers);

export const setupStore = (preloadedState?: RootState) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(api.middleware, rtkQueryErrorLogger),
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
